import { Box, Stack } from '@mui/material'
import PageHeader from 'components/common/PageHeader/PageHeader';
import CustomButton from 'components/buttons/CustomButton/CustomButton';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import useGlobalStyles from 'styles/globalStyles';
import AllRegistryPatientsTable from 'components/tables/AllRegistryPatientsTable/AllRegistryPatientsTable';
import { RegistryProvider, useRegistryContext } from 'context/RegistryContext';
import CalendarIcon from 'icons/CalendarIcon';
import CustomText from 'components/common/CustomText/CustomText';
import { colors } from 'styles/colors';
import { RegistryPatientProvider } from 'context/RegistryPatientContext';
import { useMemo } from 'react';
import { useAuth } from 'context/AuthContext';
import RegistryOptions from 'components/registry/RegistryOptions/RegistryOptions';

export default function RegistryPage() {
  const { registryId, patientId } = useParams();

  return (
    <RegistryProvider registryId={Number(registryId)}>
      <RegistryPatientProvider patientId={Number(patientId)}>
        <RegistryPageWrapper />
      </RegistryPatientProvider>
    </RegistryProvider>
  )
}


function RegistryPageWrapper() {
  const { user } = useAuth();
  const globalStyles = useGlobalStyles();
  const navigate = useNavigate();
  const { registry } = useRegistryContext();
  const location = useLocation();

  const navigateToInvitaions = () => {
    navigate(`invitations`);
  }

  const navigateToShareRegistry = () => {
    navigate('share');
  }

  const isShared = useMemo(() => {
    return registry?.owner?.id != user.id;
  }, [user, registry])

  return (
    <Box className={globalStyles.container} p={3}>
      <Box>
        <PageHeader
          title={registry?.name}
          // description={registry?.description}
          showPath
          buttons={!isShared ? [
            <RegistryOptions key='share' />
          ] : []}
        />
      </Box>

      {/* Header */}
      <Box mt={3}>
        <Box className={globalStyles.sectionContainer}>
          <Box
            className={globalStyles.sectionHeader}
            sx={{ position: 'relative' }}
          >
            <Stack flex={1} py={1.5}>

              {/* Plan Details */}
              <Box
                minWidth={150}>
                <CustomText
                  text={'Description'}
                  fontSize={18}
                  fontWeight={600}
                />
                <CustomText
                  text={registry?.description}
                  fontSize={15}
                  color={colors.secondary}
                />
              </Box>

            </Stack>

          </Box>
        </Box>
      </Box >

      <Box mt={3}>
        <AllRegistryPatientsTable showAddPatientButton />
      </Box>
    </Box>
  )
}
